import { render, staticRenderFns } from "./ReviewActionsComponent.vue?vue&type=template&id=902c7dd2&scoped=true&"
import script from "./ReviewActionsComponent.vue?vue&type=script&lang=js&"
export * from "./ReviewActionsComponent.vue?vue&type=script&lang=js&"
import style0 from "./ReviewActionsComponent.vue?vue&type=style&index=0&id=902c7dd2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "902c7dd2",
  null
  
)

export default component.exports